import { render, staticRenderFns } from "./AdjustmentTypeForm.vue?vue&type=template&id=5981619a&"
import script from "./AdjustmentTypeForm.vue?vue&type=script&lang=js&"
export * from "./AdjustmentTypeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports